import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
} from "../_helpers/ApiThunk";

const initialState = {
  getListData: {},
  getListCategoryData: {},
  softDeleteData: {},
  enableDisableData: {},
  createData: {},
  updateData: {},
  getCollectionListData: {},
  createCollectionData: {},
  updateCollectionData: {},
  deleteCollectionData: {},
  enableDisableCollectionData: {},
  FinishGetListData: {},
  CreateFinishData: {},
  softDeleteFinishData: {},
  enableDisableFinishData: {},
  getListDimensionData: {},
  createDimensionData: {},
  enableDisableDimensionData: {},
  softDeleteDimensionData: {},
  updateDimensionData: {},
  getBrandListData: {},
  createBrandData: {},
  updateBrandData: {},
  deleteBrandData: {},
  enableDisableBrandData: {},
  getWarrantyListData: {},
  enableDisableWarrantyData: {},
  softDeleteWarrantyData: {},
  createWarrantyData: {},
  getListProductData: {},
  enableDisableProductData: {},
  updateProductData: {},
  createProductData: {},
  deleteProductData: {},
  getListProductOptionData: {},
  enableDisableProductOptionData: {},
  deleteProductOptionData: {},
  createProductOptionData: {},
  updateProductOptionData: {},
  getAllBrandListData: {},
  getAllCollectionListData: {},
  getAllPatternListData: {},
  getAllListDimensionData: {},
  getAllFinishListData: {},
  getAllColorListData: {},
  getAllWarrantyListData: {},
  getAllPrivacyPolicyListData: {},
  getAllStoreListData: {},
  getAllTaxListData: {},
  getAllStoreShippingDurationListData: {},
  productOptionListData: {},
  createProductsData: {},
  getProductsData: {},
  updateProductsData: {},
  enableDisableProductCatalogsData: {},
  updateProductsByIdData: {},
  deleteProductsData: {},
  approveDisapproveData: {},
  getAllTaxRulesListData: {},
  createCategoryListData: {},
  getAllProductDocumentsData: {},
  getAllProductListTypeData: {},
  getListOfProductTypeOptionsData: {},
  getAllProductsData: {},
};
export const getList = createApiThunkPrivate(
  "getList",
  "/category/getList",
  "GET"
);
export const getListCategory = createApiThunkPrivate(
  "getListCategory",
  "/category/getList",
  "GET"
);

export const softDelete = createApiThunkPrivate(
  "softDelete",
  "/category/softDelete",
  "DELETE"
);
export const enableDisable = createApiThunkPrivate(
  "enableDisable",
  "/category/enableDisable",
  "PUT"
);
export const create = createApiThunkPrivate("create", "/category/create");
export const update = createApiThunkPrivate(
  "update",
  "/category/update",
  "PUT"
);
export const createCategoryList = createApiThunkPrivate(
  "createCategoryList",
  "/category/create"
);

//collection->>>>>>>>>>>>>
export const getCollectionList = createApiThunkPrivate(
  "getCollectionList",
  "/collections/getList",
  "GET"
);
export const createCollection = createApiThunkPrivate(
  "createCollection",
  "/collections/create",
  "POST"
);
export const updateCollection = createApiThunkPrivate(
  "updateCollection",
  "/collections/update",
  "PUT"
);
export const deleteCollection = createApiThunkPrivate(
  "deleteCollection",
  "/collections/softDelete",
  "DELETE"
);
export const enableDisableCollection = createApiThunkPrivate(
  "enableDisableCollection",
  "/collections/enableDisable",
  "PUT"
);
export const getAllCollectionList = createApiThunkPrivate(
  "getAllCollectionList",
  "/collections/getAllDocuments",
  "GET"
);

////Finish->>>>>>>>>>>
export const FinishGetList = createApiThunkPrivate(
  "FinishGetList",
  "/finish/getList",
  "GET"
);
export const CreateFinish = createApiThunkPrivate(
  "CreateFinish",
  "/finish/create",
  "POST"
);
export const softDeleteFinish = createApiThunkPrivate(
  "softDeleteFinish",
  "/finish/softDelete",
  "DELETE"
);
export const enableDisableFinish = createApiThunkPrivate(
  "enableDisableFinish",
  "/finish/enableDisable",
  "PUT"
);
export const updateFinish = createApiThunkPrivate(
  "updateFinish",
  "/finish/update",
  "PUT"
);
export const getAllFinishList = createApiThunkPrivate(
  "getAllFinishList",
  "/finish/getAllDocuments",
  "GET"
);

////Dimension--->>>>>>>>>>
export const getListDimension = createApiThunkPrivate(
  "getListDimension",
  "/dimension/getList",
  "GET"
);
export const createDimension = createApiThunkPrivate(
  "createDimension",
  "/dimension/create",
  "POST"
);
export const enableDisableDimension = createApiThunkPrivate(
  "enableDisableDimension",
  "/dimension/enableDisable",
  "PUT"
);
export const softDeleteDimension = createApiThunkPrivate(
  "softDeleteDimension",
  "/dimension/softDelete",
  "DELETE"
);
export const updateDimension = createApiThunkPrivate(
  "updateDimension",
  "/dimension/update",
  "PUT"
);
export const getAllListDimension = createApiThunkPrivate(
  "getAllListDimension",
  "/dimension/getAllDocuments",
  "GET"
);

/// brand functions===>>>>>>>>>>>>>>>>>

export const getBrandList = createApiThunkPrivate(
  "getBrandList",
  "/brands/getList",
  "GET"
);
export const createBrand = createApiThunkPrivate(
  "createBrand",
  "/brands/create",
  "POST"
);
export const updateBrand = createApiThunkPrivate(
  "updateBrand",
  "/brands/update",
  "PUT"
);
export const deleteBrand = createApiThunkPrivate(
  "deleteBrand",
  "/brands/softDelete",
  "DELETE"
);
export const enableDisableBrand = createApiThunkPrivate(
  "enableDisableBrand",
  "/brands/enableDisable",
  "PUT"
);
export const getAllBrandList = createApiThunkPrivate(
  "getAllBrandList",
  "/brands/getAllDocuments",
  "GET"
);

/// product Warranty===>>>>>>>>>>>>>>>>>
export const getWarrantyList = createApiThunkPrivate(
  "getWarrantyList",
  "/warranty/getList",
  "GET"
);
export const enableDisableWarranty = createApiThunkPrivate(
  "enableDisableWarranty",
  "/warranty/enableDisable",
  "PUT"
);
export const softDeleteWarranty = createApiThunkPrivate(
  "softDeleteWarranty",
  "/warranty/softDelete",
  "DELETE"
);
export const createWarranty = createApiThunkPrivate(
  "createWarranty",
  "/warranty/create"
);
export const updateWarranty = createApiThunkPrivate(
  "updateWarranty",
  "/warranty/update",
  "PUT"
);
export const getAllWarrantyList = createApiThunkPrivate(
  "getAllWarrantyList",
  "/warranty/getAllDocuments",
  "GET"
);

//product-options
export const getListProduct = createApiThunkPrivate(
  "getListProduct",
  "/product-type/getList",
  "GET"
);
export const enableDisableProduct = createApiThunkPrivate(
  "enableDisableProduct",
  "/product-type/enableDisable",
  "PUT"
);
export const updateProduct = createApiThunkPrivate(
  "updateProduct",
  "/product-type/update",
  "PUT"
);
export const createProduct = createApiThunkPrivate(
  "createProduct",
  "/product-type/create"
);
export const deleteProduct = createApiThunkPrivate(
  "deleteProduct",
  "/product-type/softDelete",
  "DELETE"
);
export const getAllProductListType = createApiThunkPrivate(
  "getAllProductListType",
  "/product-type/getAllDocuments",
  "GET"
);
export const getAllProducts = createApiThunkPrivate(
  "getAllProducts",
  "/product/getAllDocuments",
  "GET"
);

export const getListProductOption = createApiThunkPrivate(
  "getListProductOption",
  "/product-type/values-getList",
  "GET"
);
export const enableDisableProductOption = createApiThunkPrivate(
  "enableDisableProductOption",
  "/product-type/enableDisable",
  "PUT"
);
export const deleteProductOption = createApiThunkPrivate(
  "deleteProductOption",
  "/product-type/softDelete",
  "DELETE"
);
export const createProductOption = createApiThunkPrivate(
  "createProductOption",
  "/product-type/values-create"
);
export const updateProductOption = createApiThunkPrivate(
  "updateProductOption",
  "/product-type/values-update",
  "PUT"
);
export const getListOfProductTypeOptions = createApiThunkPrivate(
  "getListOfProductTypeOptions",
  "/product-type/values-getAllDocuments",
  "GET"
);

export const getAllPatternList = createApiThunkPrivate(
  "getAllPatternList",
  "/pattern/getAllDocuments",
  "GET"
);
export const getAllColorList = createApiThunkPrivate(
  "getAllColorList",
  "/color/getAllDocuments",
  "GET"
);
export const getAllPrivacyPolicyList = createApiThunkPrivate(
  "getAllPrivacyPolicyList",
  "/replace-policy/getAllDocuments",
  "GET"
);
export const getAllStoreList = createApiThunkPrivate(
  "getAllStoreList",
  "/store/getAllDocuments",
  "GET"
);
export const getAllTaxList = createApiThunkPrivate(
  "getAllTaxList",
  "/store-tax/getAllDocuments",
  "GET"
);
export const getAllStoreShippingDurationList = createApiThunkPrivate(
  "getAllStoreShippingDurationList",
  "/store-shipping-duration/getAllDocuments",
  "GET"
);
export const productOptionList = createApiThunkPrivate(
  "productOptionList",
  "/product-option/getOptionsWithValues",
  "GET"
);
export const getAllTaxRulesList = createApiThunkPrivate(
  "getAllTaxRulesList",
  "/taxRule/getAllDocuments",
  "GET"
);

export const createProducts = createApiThunkPrivate(
  "createProducts",
  "/product/add-product",
  "POST"
);
export const getProducts = createApiThunkPrivate(
  "getProducts",
  "/product/getList",
  "GET",
  true
);
export const updateProducts = createApiThunkPrivate(
  "updateProducts",
  "/product/getDocument",
  "GET"
);
export const enableDisableProductCatalogs = createApiThunkPrivate(
  "enableDisableProductCatalogs",
  "/product/enableDisable",
  "PUT"
);
export const updateProductsById = createApiThunkPrivate(
  "updateProductsById",
  "/product/update-product",
  "PUT"
);
export const deleteProducts = createApiThunkPrivate(
  "deleteProducts",
  "/product/softDelete",
  "DELETE"
);
export const approveDisapprove = createApiThunkPrivate(
  "approveDisapprove",
  "/product/approveDisapprove",
  "PUT"
);
export const getAllProductDocuments = createApiThunkPrivate(
  "getAllProductDocuments",
  "/product/getAllDocuments",
  "GET"
);
export const createProductInventory = createApiThunkPrivate(
  "createProductInventory",
  "/product/create-product-inventory",
  "POST"
);

export const setProductDraftData = createApiThunkPrivate(
  "setProductDraftData",
  "/product/setProductDraftData",
  "POST"
);
export const getProductDraftData = createApiThunkPrivate(
  "getProductDraftData",
  "/product/getProductDraftData",
  "GET"
);

export const productSampleDownload = createApiThunkPrivate(
  "productSampleDownload",
  "/product/downloadSampleCSV",
  "GET"
);
export const bulkUploadedHistory = createApiThunkPrivate(
  "bulkUploadedHistory",
  "/product/bulkUploadHistories",
  "GET"
);
export const applyForProductBoost = createApiThunkPrivate(
  "applyForProductBoost",
  "/product/applyForProductBoost",
  "POST"
);
export const getProductBoostList = createApiThunkPrivate(
  "getProductBoostList",
  "/product/getProductBoostList",
  "GET"
);

export const cancelPaymentOfBoost = createApiThunkPrivate(
  "cancelPaymentOfBoost",
  "/product/cancelPaymentOfBoost",
  "POST"
);

export const getImageGallery = createApiThunkPrivate(
  "getImageGallery",
  "/gallery/list",
  "GET"
);

export const getBoostList = createApiThunkPrivate(
  "getBoostList",
  "/boosts/getBoostList",
  "GET"
);

export const getAllDesignerPosts = createApiThunkPrivate(
  "getAllDesignerPosts",
  "/post/getAllDocuments",
  "GET"
);

export const getAllDesignerForumPosts = createApiThunkPrivate(
  "getAllDesignerForumPosts",
  "/forumPost/getAllDocuments",
  "GET"
);

export const applyForBoost = createApiThunkPrivate(
  "applyForBoost",
  "/boosts/applyForBoost",
  "POST"
);

export const cancelPaymentOfBoostFromStripe = createApiThunkPrivate(
  "cancelPaymentOfBoostFromStripe",
  "/boosts/cancelPaymentOfBoost",
  "POST"
);

export const getGalleryUploadStatus = createApiThunkPrivate(
  "getGalleryUploadStatus",
  "/gallery/uploading-status",
  "GET"
);

export const deleteImageGallery = createApiThunkPrivate(
  "deleteImageGallery",
  "/gallery/delete",
  "POST"
);

export const deleteExpiredBoost = createApiThunkPrivate(
  "deleteExpiredBoost",
  "/boosts/softDelete",
  "DELETE"
);

const countrySlice = createSlice({
  name: "product",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(builder, getList, "getListData");
    createExtraReducersForThunk(
      builder,
      getListCategory,
      "getListCategoryData"
    );

    createExtraReducersForThunk(builder, softDelete, "softDeleteData");
    createExtraReducersForThunk(builder, enableDisable, "enableDisableData");
    createExtraReducersForThunk(builder, create, "createData");
    createExtraReducersForThunk(builder, update, "updateData");

    // collection ==>>>>>>>>>>>>>
    createExtraReducersForThunk(
      builder,
      getCollectionList,
      "getCollectionListData"
    );
    createExtraReducersForThunk(
      builder,
      createCollection,
      "createCollectionData"
    );
    createExtraReducersForThunk(
      builder,
      updateCollection,
      "updateCollectionData"
    );
    createExtraReducersForThunk(
      builder,
      deleteCollection,
      "deleteCollectionData"
    );
    createExtraReducersForThunk(
      builder,
      enableDisableCollection,
      "enableDisableCollectionData"
    );
    // Finish  =====>>>>>>>>>>>
    createExtraReducersForThunk(builder, FinishGetList, "FinishGetListData");
    createExtraReducersForThunk(builder, CreateFinish, "CreateFinishData");
    createExtraReducersForThunk(
      builder,
      softDeleteFinish,
      "softDeleteFinishData"
    );
    createExtraReducersForThunk(
      builder,
      enableDisableFinish,
      "enableDisableFinishData"
    );
    createExtraReducersForThunk(builder, updateFinish, "updateFinishData");
    // Dimensions =========>>>>>>>
    createExtraReducersForThunk(
      builder,
      getListDimension,
      "getListDimensionData"
    );
    createExtraReducersForThunk(
      builder,
      createDimension,
      "createDimensionData"
    );
    createExtraReducersForThunk(
      builder,
      enableDisableDimension,
      "enableDisableDimensionData"
    );
    createExtraReducersForThunk(
      builder,
      softDeleteDimension,
      "softDeleteDimensionData"
    );
    createExtraReducersForThunk(
      builder,
      updateDimension,
      "updateDimensionData"
    );

    /// Brands Functions===========>>>>>>>>>>

    createExtraReducersForThunk(builder, getBrandList, "getBrandListData");
    createExtraReducersForThunk(builder, createBrand, "createBrandData");
    createExtraReducersForThunk(builder, updateBrand, "updateBrandData");
    createExtraReducersForThunk(builder, deleteBrand, "deleteBrandData");
    createExtraReducersForThunk(
      builder,
      enableDisableBrand,
      "enableDisableBrandData"
    );
    /// Product Warranty
    createExtraReducersForThunk(
      builder,
      getWarrantyList,
      "getWarrantyListData"
    );
    createExtraReducersForThunk(
      builder,
      enableDisableWarranty,
      "enableDisableWarrantyData"
    );
    createExtraReducersForThunk(
      builder,
      softDeleteWarranty,
      "softDeleteWarrantyData"
    );
    createExtraReducersForThunk(builder, createWarranty, "createWarrantyData");
    createExtraReducersForThunk(builder, updateWarranty, "updateWarrantyData");

    //Product Options
    createExtraReducersForThunk(builder, getListProduct, "getListProductData");
    createExtraReducersForThunk(
      builder,
      enableDisableProduct,
      "enableDisableProductData"
    );
    createExtraReducersForThunk(builder, updateProduct, "updateProductData");
    createExtraReducersForThunk(builder, createProduct, "createProductData");
    createExtraReducersForThunk(builder, deleteProduct, "deleteProductData");
    ///Product-Options-Value
    createExtraReducersForThunk(
      builder,
      getListProductOption,
      "getListProductOptionData"
    );
    createExtraReducersForThunk(
      builder,
      enableDisableProductOption,
      "enableDisableProductOptionData"
    );
    createExtraReducersForThunk(
      builder,
      deleteProductOption,
      "deleteProductOptionData"
    );
    createExtraReducersForThunk(
      builder,
      createProductOption,
      "createProductOptionData"
    );
    createExtraReducersForThunk(
      builder,
      updateProductOption,
      "updateProductOptionData"
    );

    createExtraReducersForThunk(
      builder,
      getAllBrandList,
      "getAllBrandListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllCollectionList,
      "getAllCollectionListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllPatternList,
      "getAllPatternListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllListDimension,
      "getAllListDimensionData"
    );
    createExtraReducersForThunk(
      builder,
      getAllFinishList,
      "getAllFinishListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllColorList,
      "getAllColorListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllWarrantyList,
      "getAllWarrantyListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllPrivacyPolicyList,
      "getAllPrivacyPolicyListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllStoreList,
      "getAllStoreListData"
    );
    createExtraReducersForThunk(builder, getAllTaxList, "getAllTaxListData");
    createExtraReducersForThunk(
      builder,
      getAllStoreShippingDurationList,
      "getAllStoreShippingDurationListData"
    );
    createExtraReducersForThunk(
      builder,
      productOptionList,
      "productOptionListData"
    );
    createExtraReducersForThunk(builder, createProducts, "createProductsData");
    createExtraReducersForThunk(builder, getProducts, "getProductsData");
    createExtraReducersForThunk(builder, updateProducts, "updateProductsData");
    createExtraReducersForThunk(
      builder,
      enableDisableProductCatalogs,
      "enableDisableProductCatalogsData"
    );
    createExtraReducersForThunk(
      builder,
      updateProductsById,
      "updateProductsByIdData"
    );
    createExtraReducersForThunk(builder, deleteProducts, "deleteProductsData");
    createExtraReducersForThunk(
      builder,
      approveDisapprove,
      "approveDisapproveData"
    );
    createExtraReducersForThunk(
      builder,
      getAllTaxRulesList,
      "getAllTaxRulesListData"
    );
    createExtraReducersForThunk(
      builder,
      createCategoryList,
      "createCategoryListData"
    );
    createExtraReducersForThunk(
      builder,
      getAllProductDocuments,
      "getAllProductDocumentsData"
    );
    createExtraReducersForThunk(
      builder,
      getAllProductListType,
      "getAllProductListTypeData"
    );
    createExtraReducersForThunk(
      builder,
      getListOfProductTypeOptions,
      "getListOfProductTypeOptionsData"
    );
    createExtraReducersForThunk(
      builder,
      createProductInventory,
      "createProductInventoryData"
    );
    createExtraReducersForThunk(builder, getAllProducts, "getAllProductsData");
  },
});

export default countrySlice.reducer;
